__turbopack_export_value__({
  "body-logo-18": "ButtonNew-module-scss-module__hvkjSW__body-logo-18",
  "body-text-12": "ButtonNew-module-scss-module__hvkjSW__body-text-12",
  "body-text-14": "ButtonNew-module-scss-module__hvkjSW__body-text-14",
  "body-text-16": "ButtonNew-module-scss-module__hvkjSW__body-text-16",
  "body-text-18": "ButtonNew-module-scss-module__hvkjSW__body-text-18",
  "body-text-20": "ButtonNew-module-scss-module__hvkjSW__body-text-20",
  "body-text-24": "ButtonNew-module-scss-module__hvkjSW__body-text-24",
  "body-text-24-2": "ButtonNew-module-scss-module__hvkjSW__body-text-24-2",
  "body-text-heading-2": "ButtonNew-module-scss-module__hvkjSW__body-text-heading-2",
  "body-text-heading-3": "ButtonNew-module-scss-module__hvkjSW__body-text-heading-3",
  "body-text-medium-14": "ButtonNew-module-scss-module__hvkjSW__body-text-medium-14",
  "body-text-medium-16": "ButtonNew-module-scss-module__hvkjSW__body-text-medium-16",
  "body-text-medium-18": "ButtonNew-module-scss-module__hvkjSW__body-text-medium-18",
  "body-text-medium2-18": "ButtonNew-module-scss-module__hvkjSW__body-text-medium2-18",
  "body-text2-14": "ButtonNew-module-scss-module__hvkjSW__body-text2-14",
  "body-text2-16": "ButtonNew-module-scss-module__hvkjSW__body-text2-16",
  "button": "ButtonNew-module-scss-module__hvkjSW__button",
  "button-primary-text": "ButtonNew-module-scss-module__hvkjSW__button-primary-text",
  "button-text": "ButtonNew-module-scss-module__hvkjSW__button-text",
  "button2-text": "ButtonNew-module-scss-module__hvkjSW__button2-text",
  "button_primary": "ButtonNew-module-scss-module__hvkjSW__button_primary",
  "button_secondary": "ButtonNew-module-scss-module__hvkjSW__button_secondary",
  "card-shadow": "ButtonNew-module-scss-module__hvkjSW__card-shadow",
  "effect-menu": "ButtonNew-module-scss-module__hvkjSW__effect-menu",
  "header-1": "ButtonNew-module-scss-module__hvkjSW__header-1",
  "main-container": "ButtonNew-module-scss-module__hvkjSW__main-container",
  "main-footer-container": "ButtonNew-module-scss-module__hvkjSW__main-footer-container",
  "main-header-container": "ButtonNew-module-scss-module__hvkjSW__main-header-container",
  "txt-12-bold": "ButtonNew-module-scss-module__hvkjSW__txt-12-bold",
  "txt-14-bold": "ButtonNew-module-scss-module__hvkjSW__txt-14-bold",
  "txt-14-bold-caps": "ButtonNew-module-scss-module__hvkjSW__txt-14-bold-caps",
  "txt-14-med": "ButtonNew-module-scss-module__hvkjSW__txt-14-med",
  "txt-16-bold": "ButtonNew-module-scss-module__hvkjSW__txt-16-bold",
  "txt-16-med": "ButtonNew-module-scss-module__hvkjSW__txt-16-med",
  "txt-18-bold": "ButtonNew-module-scss-module__hvkjSW__txt-18-bold",
  "txt-18-medium": "ButtonNew-module-scss-module__hvkjSW__txt-18-medium",
  "txt-18-medium-24": "ButtonNew-module-scss-module__hvkjSW__txt-18-medium-24",
  "txt-24-semi": "ButtonNew-module-scss-module__hvkjSW__txt-24-semi",
});
